// ADO-3749: the names the User Menu draws (AC18, AC19). Characters, not UTF-16 code units,
// so an accented name ("Seán") counts and initials the way it reads.

/** The longest first name the chip shows whole (AC18). */
export const CHIP_FIRST_NAME_MAX = 12;

function characters(value: string): string[] {
  return Array.from(value.trim());
}

/**
 * AC19: the first letter of the first name and of the last name, upper-cased ("Seán Doyle"
 * gives SD). A user with only one name gets that name's first two letters; no name gives ''.
 */
export function userInitials(firstName: string, lastName: string): string {
  const first = characters(firstName);
  const last = characters(lastName);
  if (first.length > 0 && last.length > 0) return `${first[0]}${last[0]}`.toUpperCase();
  const only = first.length > 0 ? first : last;
  return only.slice(0, 2).join('').toUpperCase();
}

/** AC18: the first name as stored, truncated with an ellipsis past 12 characters. */
export function chipFirstName(firstName: string): string {
  const name = characters(firstName);
  return name.length > CHIP_FIRST_NAME_MAX
    ? `${name.slice(0, CHIP_FIRST_NAME_MAX).join('')}…`
    : name.join('');
}
